import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { IVendor, IVendorsContact } from '../vendors.interface';
import { VendorsService } from '../vendors.service';
import * as _ from 'lodash';
import { DialogService } from '../../../../shared/services/dialog/dialog.service';
import { AuthService } from '../../../../shared/services/auth.service';

let self: any;

@Component({
  selector: 'app-vendors-modal',
  templateUrl: './vendors-modal.component.html',
  styleUrls: ['./vendors-modal.component.css']
})
export class VendorsModalComponent implements OnInit {
  dialog: MatDialogRef<any>;
  readOnly: boolean = false;
  loading: boolean = false;
  saving: boolean = false;
  vendor!: IVendor;
  form!: UntypedFormGroup;
  submitted = false;
  isDev!: boolean;
  curr!: string;

  constructor(
    public _VendorsService: VendorsService,
    private _dialogService: DialogService,
    public dialogRef: MatDialogRef<any>,
    private _dialog: MatDialog,
    private _viewContainerRef: ViewContainerRef,
    private fb: UntypedFormBuilder,
    private ref: ChangeDetectorRef,
    private _AuthService: AuthService
  ) {
    self = this;
    this.dialog = dialogRef;
  }

  ngOnInit(): void {
    this.curr = this._AuthService.currency();
    this.isDev = this._AuthService.isRole('dev');
    if (this.vendor._id) this.getVendor();
    else this.buildForm();
  }

  getVendor() {
    this.loading = true;
    this._VendorsService.getVendor(this.vendor._id || '').subscribe((vendor) => {
      this.vendor = vendor;
      this.buildForm();
      this.loading = false;
    });
  }

  get f() { return this.form.controls; }
  async buildForm() {
    let contacts = [];
    if (this.vendor.contacts) {
      for (const element of this.vendor.contacts) {
        contacts.push(await this.newContact(element as IVendorsContact));
      }
    }

    this.form = this.fb.group({
      name: [this.vendor.name, [Validators.required]],
      nif: [this.vendor.nif],
      taxAddress: [this.vendor.taxAddress],
      contacts: this.fb.array(contacts),
      isDeleted: [this.vendor.isDeleted]
    });
  }

  setEditable(value: boolean = false) {
    console.log(value);
    this.readOnly = value;
  }

  // contacts ------------------------------------------------------------------------------------------------------
  get contacts() { return this.form.get("contacts") as UntypedFormArray }
  async newContact(contact?: IVendorsContact): Promise<UntypedFormGroup> {
    if (!contact) {
      contact = await this._VendorsService.createVendorContact({
        firstname: '   ', lastname: '   ', position: '   ', email: '   ', phone: '   '
      }).toPromise() as IVendorsContact;
    }
    const _contact: any = contact;
    ['firstname', 'lastname', 'position', 'phone', 'email'].forEach(key => _contact[key] = _contact[key].trim());
    console.log(contact);
    return this.fb.group({
      _id: contact._id, firstname: contact.firstname, lastname: contact.lastname,
      position: contact.position, email: contact.email, phone: contact.phone,
    });
  }
  async addContact() { this.contacts.push(await this.newContact()); }
  removeContact(i: number) { this.contacts.removeAt(i); }

  getContactGroup(index: number): UntypedFormGroup {
    return this.contacts.controls[index] as UntypedFormGroup;
  }
  // contacts ------------------------------------------------------------------------------------------------------

  async onSubmit() {
    this.submitted = true;
    let data: IVendor = _.cloneDeep(this.form.value);
    if (this.form.invalid) return;
    this.saving = true;
    data.company = this._AuthService.companyId();
    
    if (data.contacts) {
      for (const contact of data.contacts) {
        await this._VendorsService.updateVendorContact(contact as IVendorsContact).toPromise();
      }

      data.contacts = data.contacts.map((el: any) => el._id);
    }

    if (this.vendor._id) {
      data._id = this.vendor._id;
      this._VendorsService.updateVendor(data).subscribe((vendor) => {
        this.dialog.close(vendor);
      });
    } else {
      this._VendorsService.createVendor(data).subscribe((vendor) => {
        this.dialog.close(vendor);
      });
    }
  }

  cancelSubmit() {
    if (!this.vendor._id) return this.dialog.close();
    Object.keys(this.form.controls).forEach((key) => this.form.controls[key].setErrors(null));
    this.setEditable(true);
    this.getVendor();
  }
}